import { helper } from '@ember/component/helper';

import { camelize } from '@ember/string';

import mapConfig from 'rise-ui/config/map.js';

export default helper(function mapConfigHelper([ key ]) {
  return mapConfig[key] ?? mapConfig[camelize(key)];
});
